import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoraGhostCardModuleComponent } from './scora-ghost-card-module.component';
import { TableGhostCardComponent } from './table-ghost-card/table-ghost-card.component';
import { PieChartGhostCardComponent } from "./pie-chart-ghost-card/pie-chart-ghost-card.component";
import { BarChartGhostCardComponent } from "./bar-chart-ghost-card/bar-chart-ghost-card.component";
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ScoraGhostCardModuleComponent, TableGhostCardComponent,PieChartGhostCardComponent,BarChartGhostCardComponent],
  exports:[ScoraGhostCardModuleComponent, TableGhostCardComponent,PieChartGhostCardComponent,BarChartGhostCardComponent]
})
export class ScoraGhostCardModuleModule { }



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-ghost-card-module/scora-ghost-card-module.module.ts